import { render, staticRenderFns } from "./FormScreen.vue?vue&type=template&id=49460cf2"
import script from "./FormScreen.vue?vue&type=script&lang=js"
export * from "./FormScreen.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./FormScreen.vue?vue&type=style&index=0&id=49460cf2&prod&lang=stylus")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports